




































import Vue, { PropType } from 'vue'

import { PopupMenuItem } from 'base/components/BasePopupMenu.vue'
import { Message, MessageChannel } from 'base/store/state.interface'

import AttachmentArea from './attachment/AttachmentArea.vue'
import { FileAttachment } from './attachment/file-attachment.interface'
import { ChatService } from './ChatService'
import MessageContainer from './message/MessageContainer.vue'
import ReplyBox from './reply/ReplyBox.vue'

export enum ChatAction {
  showMembers,
  showNotificationSettings,
  showChannelSettings,
  archiveChannel,
  removeChannelFromLayout
}

export default Vue.extend({
  components: {
    AttachmentArea,
    MessageContainer,
    ReplyBox
  },
  props: {
    channel: {
      type: Object as PropType<MessageChannel | undefined>,
      default: {}
    },
    messages: {
      type: Array as PropType<Message[] | undefined>,
      required: true
    },
    isPrimary: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      replyParentMessage: null as Message | null,
      messageToEdit: null as Message | null,
      collapsed: false,
      threadParentId: null
    }
  },
  computed: {
    attachments(): FileAttachment[] {
      return this.$refs.attachmentsArea.attachments
    },
    availableActions(): PopupMenuItem[] {
      if (!this.channel) return []

      let actions: PopupMenuItem[] = [
        { id: ChatAction.showMembers, title: 'Mitglieder', iconName: 'AccountGroup' },
        // { id: ChatAction.showNotificationSettings, title: 'Benachrichtigungen', iconName: 'Bell', link: '/message-channel/view.html?id=' + this.channel.id }
      ]
      if (this.channel.self_access.editable) {
        actions = actions.concat([
          { id: ChatAction.showChannelSettings, title: 'Einstellungen', iconName: 'Pencil', link: '/message-channel/update.html?id=' + this.channel.id },
          // { id: ChatAction.archiveChannel, title: 'Archivieren', iconName: 'Archive', isDestructive: true, link: '/message-channel/archive.html?id=' + this.channel.id }
        ])
      }
      if (!this.isPrimary) {
        actions = actions.concat([
          { id: ChatAction.removeChannelFromLayout, title: 'Aus Ansicht entfernen', iconName: 'Close' }
        ])
      }

      return actions
    }
  },
  methods: {
    showMessageThread(threadParentId: any) {
      this.threadParentId = threadParentId || null
    },
    selectAction(actionId: ChatAction) {
      this.$emit('selectAction', actionId)
    },
    editMessage(message: Message) {
      this.messageToEdit = message
      this.$refs.replyBox.setReplyText(message.text)
      this.$refs.replyBox.focus()
    },
    async updateMessage(message: Message, updatedText: string) {
      await ChatService.updateMessage(message, updatedText)
      this.replyParentMessage = null;
      this.$refs.replyBox.clearReplyText()
    },
    async sendMessage(text: string) {
      const parentId = this.replyParentMessage ? this.replyParentMessage.id : (this.threadParentId ? this.threadParentId : undefined)
      await ChatService.sendMessageToChannel(text, this.attachments, this.$props.channel.id, parentId)
      this.replyParentMessage = null
      this.$refs.replyBox.clearReplyText()
      this.$refs.attachmentsArea.removeAllAttachments()
      this.$refs.replyBox.focus()
    },
    async deleteMessage(messageId: number) {
      // Currently returns 500 error
      await ChatService.deleteMessage(messageId)

      // Set message content to deleted hint
      const message = this.messages.find(message => message.id === messageId)
      if (message) message.text = 'Diese Nachricht wurde gelöscht'
    },
    replyToMessage(message: Message) {
      this.replyParentMessage = message
      this.$refs.replyBox.focus()
    },
    removeCitation() {
      this.replyParentMessage = null
      this.messageToEdit = null
    },
    addAttachment() {
      this.$refs.attachmentsArea.openFileUpload()
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    }
  }
})
